import React from 'react';
import { Typography, Button, Box, Paper, Grid, Card, CardContent, CardActions, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import DownloadIcon from '@mui/icons-material/Download';

const HomePage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box>
      {/* Hero Section */}
      <Paper 
        elevation={0} 
        sx={{ 
          p: 4, 
          mb: 4, 
          borderRadius: 3,
          background: 'linear-gradient(120deg, #1976d2 0%, #64b5f6 100%)',
          color: 'white',
          textAlign: 'center'
        }}
      >
        <Box sx={{ maxWidth: 800, mx: 'auto', py: 4 }}>
          <Typography variant="h3" component="h1" gutterBottom fontWeight="bold">
            Convertissez vos factures en format FacturX
          </Typography>
          <Typography variant="h6" sx={{ mb: 4, opacity: 0.9 }}>
            Solution simple et rapide pour convertir vos factures PDF classiques en format Factur-X conforme à la réglementation française
          </Typography>
          <Button 
            variant="contained" 
            size="large" 
            component={RouterLink} 
            to="/upload"
            sx={{ 
              bgcolor: 'white', 
              color: 'primary.main',
              px: 4,
              py: 1.5,
              fontSize: '1.1rem',
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.9)',
              }
            }}
            startIcon={<UploadFileIcon />}
          >
            Convertir une facture
          </Button>
        </Box>
      </Paper>

      {/* Features Section */}
      <Typography variant="h4" component="h2" gutterBottom sx={{ mb: 3, textAlign: 'center' }}>
        Comment ça fonctionne
      </Typography>
      
      <Grid container spacing={3} sx={{ mb: 6 }}>
        <Grid item xs={12} md={4}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardContent sx={{ flexGrow: 1 }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                <UploadFileIcon color="primary" sx={{ fontSize: 60 }} />
              </Box>
              <Typography variant="h5" component="h3" gutterBottom textAlign="center">
                1. Importez votre facture
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Téléchargez votre facture au format PDF. Notre système prend en charge tous les formats de factures couramment utilisés.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} md={4}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardContent sx={{ flexGrow: 1 }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                <AutoAwesomeIcon color="primary" sx={{ fontSize: 60 }} />
              </Box>
              <Typography variant="h5" component="h3" gutterBottom textAlign="center">
                2. Vérifiez les données
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Notre OCR extrait automatiquement les données de votre facture. Vérifiez et complétez les informations si nécessaire.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} md={4}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardContent sx={{ flexGrow: 1 }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                <DownloadIcon color="primary" sx={{ fontSize: 60 }} />
              </Box>
              <Typography variant="h5" component="h3" gutterBottom textAlign="center">
                3. Téléchargez votre Factur-X
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Générez et téléchargez votre facture au format Factur-X, prête à être utilisée et conforme à la réglementation.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* CTA Section */}
      <Paper 
        elevation={0} 
        sx={{ 
          p: 4, 
          borderRadius: 3,
          bgcolor: 'primary.light',
          color: 'white',
          textAlign: 'center'
        }}
      >
        <Typography variant="h5" gutterBottom>
          Prêt à convertir vos factures ?
        </Typography>
        <Button 
          variant="contained" 
          size="large" 
          component={RouterLink} 
          to="/upload"
          sx={{ 
            mt: 2,
            bgcolor: 'white', 
            color: 'primary.main',
            '&:hover': {
              bgcolor: 'rgba(255, 255, 255, 0.9)',
            }
          }}
        >
          Commencer maintenant
        </Button>
      </Paper>
    </Box>
  );
};

export default HomePage;
